import { measureCompHeight } from './utils';
export default function create(options, dom) {
  const measures = {
    compHeight: 0
  };
  if (dom) {
    measureCompHeight(measures, dom);
  }
  const {
    angle = 20,
    direction = 'counter-clockwise'
  } = options.namedEffect;
  return [{
    ...options,
    part: 'BG_MEDIA',
    startOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    endOffset: {
      name: 'cover',
      offset: {
        type: 'percentage',
        value: 0
      }
    },
    get endOffsetAdd() {
      return `calc(100vh + ${measures.compHeight}px)`;
    },
    keyframes: [{
      transform: `skewY(${direction === 'counter-clockwise' ? angle : -angle}deg)`
    }, {
      transform: `skewY(${direction === 'counter-clockwise' ? -angle : angle}deg)`
    }]
  }];
}
//# sourceMappingURL=BgSkew.js.map